import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.scss';
interface BaseProps {
  content: string;
  duration: number;
  className?: string;
  selfAdaption: boolean;
  domWrap: HTMLDivElement;
}

const ToastBox: React.FC<BaseProps> = (props) => {
  const { content, duration, domWrap, className, selfAdaption } = props;
  useEffect(() => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(domWrap);
      document.body.removeChild(domWrap);
    }, duration);
  }, []);
  return (
    <div
      className={`${styles['mask-wrap']} ${
        !selfAdaption ? styles['old-message-wrapper'] : ''
      }`}
    >
      <div className={`${styles['toast-content-wrapper']} ${className || ''}`}>
        <div
          className={`${styles['loading-content']} toast-content-info-style`}
        >
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};
export default ToastBox;
